//* Import necessary modules
import { useState } from "react";

//! This file contains the logic to handle the CSV file upload and validation for the teachers
import { CSVTeacher as BaseCSVTeacher } from "../../../utils/csv/csv-validatorTeacher";

//? Type for the structure of Teacher CSV data
export interface CSVTeacher extends BaseCSVTeacher {
  name: string;
  email: string;
  isValid: boolean;
  error?: string;
}

export function useCSVTeacherData() {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [CSVTeacherError, setCSVTeacherError] = useState<string | null>(null);
  const [CSVTeacherPreviewData, setCSVTeacherPreviewData] = useState<
    CSVTeacher[]
  >([]);
  const [invalidData, setInvalidData] = useState<CSVTeacher[]>([]);
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  const isValidEmail = (email: string): boolean => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const isValidName = (name: string): boolean => {
    return name.length >= 3;
  };
  // Function to validate a teacher
  function validateTeacher(teacher: CSVTeacher): CSVTeacher {
    let isValid = true;
    let error = "";
    if (!isValidName(teacher.name)) {
      isValid = false;
      error += "Nome inválido. ";
    }
    if (!isValidEmail(teacher.email)) {
      isValid = false;
      error += "Email inválido.";
    }
    return {
      ...teacher,
      isValid,
      error: isValid ? undefined : error,
    };
  }
  // Function to handle CSV file upload and validation
  const handleCSVTeacherFileUpload = async (file: File) => {
    setSelectedFile(file);
    if (file) {
      try {
        const text = await file.text();
        const rows = text
          .split("\n")
          .map((row: string) =>
            row.split(",").map((cell: string) => cell.trim())
          )
          .filter((row) => row.length === 2 && row[0] && row[1]);
        const validTeachers: CSVTeacher[] = [];
        const invalidTeachers: CSVTeacher[] = [];
        rows.forEach((row) => {
          const name = row[0];
          const email = row[1];
          const teacher = validateTeacher({ name, email, isValid: true });
          if (teacher.isValid) {
            validTeachers.push(teacher);
          } else {
            invalidTeachers.push(teacher);
          }
        });
        setCSVTeacherError(null);
        setCSVTeacherPreviewData(validTeachers);
        setInvalidData(invalidTeachers);
      } catch (error) {
        setCSVTeacherError(
          error instanceof Error ? error.message : "Erro ao ler o arquivo."
        );
      }
    }
  };
  return {
    selectedFile,
    setSelectedFile,
    CSVTeacherError,
    CSVTeacherPreviewData,
    invalidData,
    fileInputKey,
    setFileInputKey,
    validateTeacher,
    handleCSVTeacherFileUpload,
    setCSVTeacherError,
    setCSVTeacherPreviewData,
    setInvalidData,
  };
}
